import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { utils } from "../../Helpers/utils";
import { plusIcon, Toast } from "../../Components";
import AccountTransactionDetail from "./AccountTransactionDetail";
import ModalBilling from "./ModalBilling";
import ModalToken from "./ModalToken";
import TokenTransactionDetail from "./TokenTransactionDetail";
import ModalTransaction from "./ModalTransaction";

import {
  billingService,
  planService,
  accountService,
  tokenService,
  orderService,
} from "../../Services";
import { storageHandler } from "../../Helpers/storage";
import { AppConfirmSubscription } from "../../Components/AppConfirmSubscription";
import Order from "../../Pages/Order/Order";

const selectDescList = [
  { id: "1", value: "All transactions" },
  { id: "description", value: "Description" },
  { id: "30days", value: "30 days" },
  { id: "lastyr", value: "Last year " },
  { id: "transaction_type", value: "Charge type" },
  { id: "amount", value: "Amount" },
];

export default function Billing({
  setAuth,
  setModal,
  NotifModul,
  user,
  profiles,
  setModalNotification,
  closeCartPanel,
  cartItem,
}) {
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [selectDesc, setselectDesc] = useState(selectDescList[0].value);
  const [modalBill, setModalBill] = useState(null);
  const [modalAddToken, setModalAddToken] = useState(null);
  const [modalDataBill, setModalDataBill] = useState(null);
  const [isloaded, setIsLoaded] = useState(false);
  const [isLoadedToken, setIsLoadedToken] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageOrder, setPageOrder] = useState(1);
  const [pageSizeOrder, setPageSizeOrder] = useState(10);
  const [displayedOrders, setDisplayedOrders] = useState([]);
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [walletDetails, setWalletDetails] = useState([]);
  const [toastList, setToastList] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [paginationDataToken, setPaginationDataToken] = useState({});
  const [searchList, setSearchList] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [disableSearchBox, setDisableSearchBox] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const [isBalanceAdded, setIsBalanceAdded] = useState(false);
  const [isTokenAdded, setIsTokenAdded] = useState(false);
  const [loadSubscription, setLoadSubscription] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const success = queryParams.get("success");
  console.log("🚀 ~ Billing ~ success:", success);
  const [isAddFundsOpen, setIsAddFundsOpen] = useState(
    location.state
      ? location.state.openAddFunds === true
        ? true
        : false
      : false
  );
  const [modalConfirm, setModalConfirm] = useState(false);
  const [isTokenLoaded, setIsTokenLoaded] = useState(false);
  const [tokenAvailable, setTokenAvailable] = useState(null);
  const [tokenPlan, setTokenPlan] = useState([]);
  const [isTokenPlanLoaded, setIsTokenPlanLoaded] = useState(false);
  const [tokenTransaction, setTokenTransaction] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(0);
  const [getCart, setGetCart] = useState(false);
  const tabs = ["Current Plan", "Account Transaction", "Orders"];

  const [paginationDataOrder, setPaginationDataOrder] = useState({});
  const [isLoadedOrder, setIsLoadedOrder] = useState(false);

  const userToken = storageHandler.getToken();

  useEffect(() => {
    // if (success === 1) {
      setUserInfo();
    // }
    let successRechargeMessage =
      searchParams.get("recharge") !== null
        ? searchParams.get("recharge") === 1
          ? "Token purchase successfully"
          : ""
        : "";
    if (successRechargeMessage !== "") {
      addToast({
        error: false,
        msg: successRechargeMessage,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  }, []);

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'accounttransaction') {
      setActiveTab(1);
    } else if (tab === 'orders') {
      setActiveTab(2);
    } else {
      setActiveTab(0);
      navigate(`${location.pathname}?tab=currentplan`, { replace: true });
    }
  }, []);

  useEffect(() => {
    if (activeTab === 1) {
      navigate(`${location.pathname}?tab=accounttransaction`, { replace: true });
    } else if (activeTab === 2) {
      navigate(`${location.pathname}?tab=orders`, { replace: true });
    } else {
      navigate(`${location.pathname}?tab=currentplan`, { replace: true });
    }
  }, [activeTab]);

  function capitalizeFirstLetter(string) {
    if (string !== "" && string !== null) {
      return string?.charAt(0)?.toUpperCase() + string?.slice(1);
    } else {
      return "";
    }
  }

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList?.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  useEffect(() => {
    if (modalBill) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modalBill]);

  useEffect(() => {
    //delete location.state.openAddFunds;
    if (isAddFundsOpen === true) {
      setModalBill("addFunds");
    } else {
      setModalBill(null);
    }
  }, []);

  useEffect(() => {
    async function getTokenData() {
      try {
        const res = await tokenService.getTokenData();
        if (res?.data?.[0]) {
          setTokenAvailable(res.data[0]);
        }
        setIsTokenLoaded(true);
      } catch (err) {
        console.error("Token data fetch error:", err);
        setIsTokenLoaded(true);
        addToast({
          error: true,
          msg: err?.message || "Failed to load token information",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
    getTokenData();
    setGetCart(!getCart);
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await billingService.getAllTokenPlan();
        if (res?.data) {
          let productDetails = [];
          res.data.map((item) => {
            if (item?.product_id && item?.product_name && item?.price) {
              productDetails.push({
                id: item.product_id,
                value: item.product_name + " ($" + item.price + ")",
                amount: item.price,
              });
            }
          });
          setTokenPlan(productDetails);
        }
        setIsTokenPlanLoaded(true);
      } catch (err) {
        console.error("Token plan fetch error:", err);
        setIsTokenPlanLoaded(true);
        addToast({
          error: true,
          msg: err?.message || "Failed to load token plans",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
    fetchData();
  }, []);

  async function fetchDataSubData() {
    try {
      let filter = "";
      if (searchString !== "") {
        if (filter !== "") {
          filter += "&filter[" + selectDesc + "]=" + searchString;
        } else {
          filter = "filter[" + selectDesc + "]=" + searchString;
        }
      } else {
        if (selectDesc === "lastyr" || selectDesc === "30days") {
          filter = "filter[created_at]=" + selectDesc;
        }
      }
      const res = await billingService.getAll({
        page: page,
        pageSize,
        filter: filter,
      });
      if (
        res?.transaction_details?.["meta"] &&
        res.transaction_details["meta"]["pagination"]
      ) {
        setPaginationData(res.transaction_details["meta"]["pagination"]);
      }
      setLoadSubscription(false);
      setTransactionDetails(res?.transaction_details?.data || []);
      setWalletDetails(res?.wallet_details || {});
      setSubscriptionDetails(res?.subscription_details || {});
      setIsLoaded(true);
    } catch (err) {
      console.error("Billing data fetch error:", err);
      setLoadSubscription(false);
      setIsLoaded(true);
      addToast({
        error: true,
        msg: err?.message || "Failed to load billing data",
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  }

  useEffect(() => {
    async function fetchTokenData() {
      try {
        let filter = "";
        if (searchString !== "") {
          if (filter !== "") {
            filter += "&filter[" + selectDesc + "]=" + searchString;
          } else {
            filter = "filter[" + selectDesc + "]=" + searchString;
          }
        } else {
          if (selectDesc === "lastyr" || selectDesc === "30days") {
            filter = "filter[created_at]=" + selectDesc;
          }
        }
        const res = await tokenService.getTokenTxn({
          page: page,
          pageSize,
          filter: filter,
        });
        if (
          res?.token_details?.["meta"] &&
          res.token_details["meta"]["pagination"]
        ) {
          setPaginationDataToken(res.token_details["meta"]["pagination"]);
        }
        setTokenTransaction(res?.token_details?.data || []);
        setIsLoadedToken(true);
      } catch (err) {
        console.error("Token data fetch error:", err);
        setIsLoadedToken(true);
        addToast({
          error: true,
          msg: err?.message || "Failed to load token data",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }

    async function fetchOrderData() {
      try {
        let filter = "";
        if (searchString !== "") {
          if (filter !== "") {
            filter += "&filter[timespan]=" + searchString;
          } else {
            filter = "filter[timespan]=" + searchString;
          }
        } else {
          if (selectDesc === "lastyr" || selectDesc === "30days") {
            filter = "filter[created_at]=" + selectDesc;
          }
        }
        const res = await orderService.getAll({
          page: pageOrder, // Instead of 'page'
          pageSize: pageSizeOrder, // Instead of 'pageSize'
          filter: filter,
        });
        console.log("🚀 ~ fetchOrderData ~ res:", res);
        const allOrders = res?.data || [];

        // Calculate pagination for 4 items per page
        const startIndex = (pageOrder - 1) * pageSizeOrder;
        const endIndex = startIndex + pageSizeOrder;
        const paginatedOrders = allOrders.slice(startIndex, endIndex);
        setDisplayedOrders(paginatedOrders);

        // Update pagination data
        const totalPages = Math.ceil(allOrders.length / pageSizeOrder);
        setPaginationDataOrder({
          current_page: pageOrder,
          per_page: pageSizeOrder,
          total: allOrders.length,
          total_pages: totalPages,
        });
        setIsLoadedOrder(true);
      } catch (err) {
        console.error("Order data fetch error:", err);
        setIsLoadedOrder(true);
        addToast({
          error: true,
          msg: err?.message || "Failed to load order data",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }

    if (activeTab === 1 || loadSubscription === true) {
      fetchDataSubData();
    }

    if (activeTab === 0) {
      fetchTokenData();
    }

    if (activeTab === 2) {
      fetchOrderData();
    }
  }, [page, searchList, cartItem, activeTab, pageOrder]);

  const downloadCsv = async () => {
    try {
      let filter = "";
      if (searchString !== "") {
        if (filter !== "") {
          filter += "&filter[" + selectDesc + "]=" + searchString;
        } else {
          filter = "filter[" + selectDesc + "]=" + searchString;
        }
      } else {
        if (selectDesc === "lastyr" || selectDesc === "30days") {
          filter = "filter[created_at]=" + selectDesc;
        }
      }
      if (activeTab === 1) {
        const response = await billingService.getAll({
          page: page,
          pageSize,
          filter: filter,
          fileType: "csv",
        });
        utils.downloadFile(response, "brandBilling_page_" + page + ".csv");
      }

      if (activeTab === 0) {
        const response = await tokenService.getTokenTxn({
          page: page,
          pageSize,
          filter: filter,
          fileType: "csv",
        });
        utils.downloadFile(response, "tokenTxn_page_" + page + ".csv");
      }

      if (activeTab === 2) {
        const response = await orderService.getAll({
          page: pageOrder,
          pageSize: pageSizeOrder,
          filter: filter,
          fileType: "csv",
        });
        utils.downloadFile(response, "orders_page_" + page + ".csv");
      }
    } catch (err) {
      addToast({
        error: true,
        msg: err,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  const onPaginate = (page) => {
    setPage(page);
  };
  const onPaginateOrder = (page) => {
    setPageOrder(page);
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        search();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [searchString]);

  const setUserInfo = async () => {
    if (userToken) {
      try {
        const res = await accountService.loginViaToken(userToken);
        console.log("🚀 ~ setUserInfo ~ user data saved to local storage:", res);
      } catch (error) {
        console.error("🚀 ~ setUserInfo ~ error:", error);
      }
    }
  };

  const changeMediumDesc = (item) => {
    setselectDesc(item.id);
    setPage(1);
    setPageOrder(1);
    if (item.id === "lastyr" || item.id === "30days") {
      setDisableSearchBox(true);
    } else {
      setDisableSearchBox(false);
    }
    setSearchString("");
    setSearchList(!searchList);
  };

  const setSearchStringText = (event) => {
    if (event.target.value === "") {
      setSearchList(!searchList);
    }
    setSearchString(event.target.value);
  };

  const search = () => {
    setSearchList(!searchList);
    setPage(1);
    setPageOrder(1);
  };

  async function cancelsub() {
    try {
      if (!subscriptionDetails?.cancelurl) {
        throw new Error("Cancel URL not available");
      }
      const response = await planService.cancelUrl(
        subscriptionDetails["cancelurl"]
      );
      addToast({
        error: false,
        msg: response?.message || "Subscription cancelled successfully",
        id: `${Date.now()}-${toastList.length}`,
      });
      setUserInfo();
      await accountService.refreshToken(function () {});
    } catch (err) {
      console.error("Cancel subscription error:", err);
      addToast({
        error: true,
        msg: err?.message || "Failed to cancel subscription",
        id: `${Date.now()}-${toastList.length}`,
      });
    }
    fetchDataSubData();
    setModalConfirm(null);
  }

  const gotoPricing = () => {
    navigate("/brand/pricing");
  };

  const confirmCancel = () => {
    setModalConfirm("confirm");
  };

  return (
    <>
      <div className="main">
        <div className="main__inner">
          {isloaded && (
            <div className="billing">
              {subscriptionDetails?.isAnyFailPlan === 1 && (
                <div className="billing__row  ">
                  <div className="billing__col subscription subscriptionFailed">
                    Subscription Payment Fail
                  </div>
                </div>
              )}
              <div className="billing__row ">
                <div className="billing__col !rounded-lg subscription">
                  {subscriptionDetails &&
                  subscriptionDetails?.end_date !== "" &&
                  subscriptionDetails?.cancelurl !== "" ? (
                    <>
                      <div className="subscriptionType">
                        Subscription:
                        <button
                          className="button tertiary big subscribeToPricing "
                          onClick={gotoPricing}
                        >
                          {subscriptionDetails &&
                            capitalizeFirstLetter(
                              subscriptionDetails?.product_name
                            )}
                          {subscriptionDetails &&
                            " ($" +
                              subscriptionDetails?.price +
                              " " +
                              capitalizeFirstLetter(
                                subscriptionDetails?.billing_cycle
                              ) +
                              ")"}
                        </button>
                      </div>
                      <div className="subscriptionData ">
                        {subscriptionDetails?.is_trial === 1 ? (
                          <span className="font-semibold w-full rounded-[30px] border bg-green-100 text-green-800 border-green-500 mt-[-3px] text-sm justify-center  ps-4 pe-[7px] py-1 max-w-[120px] hover:border-green-700 hover:text-white hover:bg-gradient-to-t from-green-700 to-green-900">
                            Trial Ends On
                          </span>
                        ) : (
                          " Renew Date: "
                        )}{" "}
                        <span className="ml-1">
                          {" "}
                          : {subscriptionDetails.end_date}
                        </span>
                      </div>
                      <div className="cancel">
                        {subscriptionDetails["cancelurl"] !== "" && (
                          <button
                            className="button tertiary big "
                            onClick={confirmCancel}
                          >
                            Cancel Subscription
                          </button>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="subscriptionType">
                        <span className="paddingSubscribeToSubscribe">
                          Subscription:
                        </span>
                        {subscriptionDetails?.status === "canceled" ? (
                          <button
                            className="button tertiary big subscribeToPricing"
                            onClick={gotoPricing}
                          >
                            {subscriptionDetails &&
                              capitalizeFirstLetter(
                                subscriptionDetails?.product_name
                              )}
                            {subscriptionDetails &&
                              " ($" +
                                subscriptionDetails?.price +
                                " " +
                                capitalizeFirstLetter(
                                  subscriptionDetails?.billing_cycle
                                ) +
                                ")"}{" "}
                            - Active till {subscriptionDetails?.end_date}
                          </button>
                        ) : (
                          <button
                            className="button tertiary big "
                            onClick={gotoPricing}
                          >
                            Subscribe Now
                          </button>
                        )}
                      </div>
                      <div className="subscriptionData"> RenewDate: N/A</div>
                      {subscriptionDetails?.status === "canceled" && (
                        <button
                          className="button tertiary big "
                          onClick={gotoPricing}
                        >
                          Reactivate Subscription
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="billing__row">
                <div className="billing__col !rounded-lg">
                  <h5>Value of committed campaigns</h5>
                  <h2>{walletDetails ? walletDetails.committed : "$0"}</h2>
                </div>
                <div className="billing__col !rounded-lg ">
                  <div className="billing__col-title">
                    <h5>Available balance</h5>
                    <button
                      className="button tertiary big"
                      onClick={() => setModalBill("addFunds")}
                    >
                      Add funds {plusIcon}
                    </button>
                  </div>
                  <h2>{walletDetails ? walletDetails.available : "$0"}</h2>
                </div>
              </div>
              {isLoadedToken && (
                <div className="">
                  <div className="">
                    {/* Tab Buttons */}
                    <div className="tabs">
                      {tabs.map((tab, index) => (
                        <button
                          key={index}
                          className={`tab-button !rounded-lg ${
                            activeTab === index ? "active" : ""
                          }`}
                          onClick={() => setActiveTab(index)}
                        >
                          {tab}
                        </button>
                      ))}
                    </div>
                    {/* Tab Content */}
                    <div className="tab-content">
                      {activeTab === 1 && (
                        <AccountTransactionDetail
                          searchString={searchString}
                          disableSearchBox={disableSearchBox}
                          search={search}
                          setSearchStringText={setSearchStringText}
                          changeMediumDesc={changeMediumDesc}
                          selectDescList={selectDescList}
                          onPaginate={onPaginate}
                          paginationData={paginationData}
                          downloadCsv={downloadCsv}
                          setModalAddToken={setModalAddToken}
                          setModalBill={setModalBill}
                          setModalDataBill={setModalDataBill}
                          transactionDetails={transactionDetails}
                        ></AccountTransactionDetail>
                      )}
                      {activeTab === 0 && (
                        <TokenTransactionDetail
                          onPaginate={onPaginate}
                          paginationDataToken={paginationDataToken}
                          downloadCsv={downloadCsv}
                          setModalAddToken={setModalAddToken}
                          tokenTransaction={tokenTransaction}
                          tokenAvailable={tokenAvailable}
                          subscriptionDetails={subscriptionDetails}
                        ></TokenTransactionDetail>
                      )}
                      {activeTab === 2 && (
                        <Order
                          orderDetails={displayedOrders}
                          paginationData={paginationDataOrder}
                          isloaded={isLoadedOrder}
                          onPaginate={onPaginateOrder}
                          user={user}
                          goToPricing={gotoPricing}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {toastList && <Toast list={toastList} setList={setToastList} />}
      <AnimatePresence>
        {modalBill === "addFunds" && (
          <ModalBilling
            open={modalBill === "addFunds"}
            close={() => {
              setIsBalanceAdded(false);
              setModalBill(null);
            }}
            addToast={addToast}
            setIsBalanceAdded={setIsBalanceAdded}
          />
        )}
        {modalAddToken === "addToken" && (
          <ModalToken
            close={() => {
              setIsTokenAdded(false);
              setModalAddToken(null);
            }}
            addToast={addToast}
            tokenPlan={tokenPlan}
            setIsTokenAdded={setIsTokenAdded}
          />
        )}
        {modalBill === "transaction" && (
          <ModalTransaction
            {...modalDataBill}
            close={() => setModalBill(null)}
          />
        )}
        {modalConfirm === "confirm" && (
          <>
            <AppConfirmSubscription
              open={modalConfirm === "confirm"}
              onClose={() => setModalConfirm(false)}
              setModalConfirm={setModalConfirm}
              cancelsub={cancelsub}
            />
          </>
        )}
      </AnimatePresence>
    </>
  );
}
